import React, { useEffect, useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import './indexpageCss/IndexGallery.css';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-cube';
import { EffectCube, Autoplay } from 'swiper/modules';

const IndexGallery = () => {

    const [cdata, setCdata] = useState([]);

    useEffect(() => {
        const clientimgfetch = async () => {
            try {
                const res = await fetch('https://backend.corporateeventplanner.in/api/cyj-client-gallery');
                const data = await res.json();
                setCdata(data || []);
            } catch (error) {
                console.warn(error);
            }
        };
        clientimgfetch();
    }, []);


    // Only valid slides memoized
    const slides = useMemo(() => {
        return cdata.map((item, index) => (
                <SwiperSlide className="indexgalleryImageBox" key={item.id || index}>
                    <img
                        src={item.client_gallery[0]}
                        alt={item.name}
                        loading="lazy"
                    />
                    <div className="clientLogo">
                        <img
                            src={item.logo}
                            alt={item.name}
                            loading="lazy"
                        />
                    </div>
                </SwiperSlide>
            ));
    }, [cdata]);

    return (
        <section className="indexgallerySection">
            <div className="innerindexgallerySection">

                <div className="indexFirstgalleryBox">
                    <div className="headingGallery">
                        <h2>Our Portfolio</h2>
                        <p>Our Recent Exposures</p>
                        <Link to="our-portfolio" id="indgalleryBtn">
                            View More Photos <i className="fa-solid fa-arrow-right-long"></i>
                        </Link>
                    </div>
                </div>

                <div className="indexSecoundgalleryBox">
                    <Swiper
                        effect="cube"
                        grabCursor
                        cubeEffect={{
                            shadow: true,
                            slideShadows: true,
                            shadowOffset: 20,
                            shadowScale: 0.94,
                        }}
                        autoplay={{
                            delay: 2500,
                            disableOnInteraction: false,
                        }}
                        speed={1000}
                        modules={[EffectCube, Autoplay]}
                        className="mySwiper idxinergbox"
                    >
                        {slides}
                    </Swiper>
                </div>

            </div>
        </section>
    );
};

export default IndexGallery;